// Compute [start, end] ISO date strings (YYYY-MM-DD) for named presets.
// Uses LOCAL timezone via en-CA locale (YYYY-MM-DD) — never UTC.
const iso = (d) => d.toLocaleDateString("en-CA");
const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

export function rangeFor(mode, monthYYYYMM, year) {
  const now = new Date();
  if (mode === "all") return { start: "", end: "" };
  if (mode === "today") { const s = iso(startOfDay(now)); return { start: s, end: s }; }
  if (mode === "week") {
    const s = startOfDay(now); s.setDate(s.getDate() - 6);
    return { start: iso(s), end: iso(now) };
  }
  if (mode === "month" && monthYYYYMM) {
    const [y, m] = monthYYYYMM.split("-").map(Number);
    const end = new Date(y, m, 0); // last day of the month
    return { start: `${monthYYYYMM}-01`, end: iso(end) };
  }
  if (mode === "year" && year) {
    return { start: `${year}-01-01`, end: `${year}-12-31` };
  }
  return { start: "", end: "" };
}

export const currentMonth = () => new Date().toLocaleDateString("en-CA").slice(0, 7);
export const currentYear = () => String(new Date().getFullYear());
